import _ from "lodash";
import React, { ReactElement, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Application, ApplicationService } from "../";

import DatePicker from "react-datepicker";
import useForceUpdate from "use-force-update";

import { CountryDropdown } from "react-country-region-selector";
import { date, number, object, string } from "yup";
import { InputErrorMessage } from "../../ui";

import "react-datepicker/dist/react-datepicker.css";
import { ApplicationDropzone } from "../";
import { Lead } from "../../leads";

interface IProps {
	application: Application;
	jumpToStep?: any;
	nextStep: number;
}

export const StepThreeCompany = (props: IProps): ReactElement => {
	const [errors, setErrors] = useState(null);
	const forceUpdate = useForceUpdate();

	let schemaOptions: any;
	let schemaObject: any;

	const applicationService = new ApplicationService();
	const application = props.application;

	const courses = [
		"Financial Securities Management",
		"Microsoft Office (Intermediate to Advance)",
		"Human Resource Management",
		"Microsoft Office (Beginners to Intermediate)",
		"Payroll, Staff Benefits and Statutory Deductions",
		"Records &amp; Information Management",
		"Supervisory Management",
	];

	const genders = ["Male", "Female", "Other"];

	const applyingFor = ["An Individual", "A Group"];

	const uploadedAttachements = application.attachmentsForPrefix(
		"paperbased-app",
	);

	schemaOptions = {
		courseName: string().required("Please select a course"),
	};
	schemaObject = {
		courseName: application.courseName,
	};

	if (application.applyingForA === applyingFor[0]) {
		if (!application.participant) {
			application.participant = new Lead();
		}

		const schemaOptionsParticipant = {
			firstName: string().required("First Name is a required field"),
			lastName: string().required("Last Name is a required field"),
			email: string()
				.email("Email must be a valid email")
				.required("Email is a required field"),
			country: string().required("Country is a required field"),
			phone: string().required("Phone is a required field"),
			course: string().required("Please select a course"),
			birthday: date().required("Birthday is a required field"),
			gender: string().required("Gender is a required field"),
		};

		const schemaObjectParticipant = {
			firstName: application.participant.firstName,
			lastName: application.participant.lastName,
			email: application.participant.email,
			country: application.participant.country,
			phone: application.participant.phone,
			course: application.courseName,
			birthday: application.participant.birthday,
			gender: application.participant.gender,
		};

		schemaOptions = { ...schemaOptions, ...schemaOptionsParticipant };
		schemaObject = { ...schemaObject, ...schemaObjectParticipant };
	} else {
		const schemaOptionsCompany = {
			groupSize: string().required("Please enter the group size"),
			hasPaperBasedApplications: string().required(
				"Please indicate if you have paper based applications",
			),
			hasUploadedPaperbasedApplications: number().when(
				"hasPaperBasedApplications",
				{
					is: "Yes",
					then: number().min(
						1,
						"Please upload atleast 1 paper based application.",
					),
					otherwise: number().min(0),
				},
			),
		};

		const schemaObjectCompany = {
			groupSize: application.groupSize,
			hasPaperBasedApplications: application.hasPaperBasedApplications,
			hasUploadedPaperbasedApplications: uploadedAttachements.length,
		};

		schemaOptions = { ...schemaOptions, ...schemaOptionsCompany };
		schemaObject = { ...schemaObject, ...schemaObjectCompany };
	}

	const schema = object(schemaOptions);

	const validateStep = () => {
		schema
			.validate(schemaObject, { abortEarly: false })
			.then(valid => {
				if (valid) {
					setErrors(null);
					if (props.application.currentStep < 3) {
						props.application.currentStep = 3;
					}
					applicationService.updateApplication(application);
					props.jumpToStep(props.nextStep);
				}
			})
			.catch(err => {
				setErrors(err);
			});
	};

	const participantList = () => {
		if (!application.participants) {
			application.participants = [
				{
					course: "",
					numParticipants: "",
					startDate: new Date(),
				},
			];
		}

		const participantFields = application.participants.map(
			(participant, idx) => {
				if (participant.startDate) {
					participant.startDate = new Date(participant.startDate);
				}

				return (
					<Row className="mb-3" key={`participant-${idx}`}>
						<Col sm={4}>
							<Form.Group controlId={`course-${idx}`}>
								<Form.Control
									size="lg"
									defaultValue={participant.course}
									onChange={(event: any) => {
										if (
											application.participants &&
											application.participants[idx]
										) {
											application.participants[
												idx
											].course = event.target.value;
											forceUpdate();
										}
									}}
								/>
							</Form.Group>
						</Col>
						<Col sm={4}>
							<Form.Group controlId={`numParticipants-${idx}`}>
								<Form.Control
									size="lg"
									defaultValue={participant.numParticipants}
									onChange={(event: any) => {
										if (
											application.participants &&
											application.participants[idx]
										) {
											application.participants[
												idx
											].numParticipants =
												event.target.value;
											forceUpdate();
										}
									}}
								/>
							</Form.Group>
						</Col>
						<Col sm={3}>
							<Form.Group controlId={`start-${idx}`}>
								<DatePicker
									showYearDropdown
									className="form-control form-control-lg"
									selected={participant.startDate}
									onChange={(d: Date) => {
										if (
											application.participants &&
											application.participants[idx]
										) {
											application.participants[
												idx
											].startDate = d;
											forceUpdate();
										}
									}}
								/>
								<InputErrorMessage
									errors={errors}
									field="birthday"
								/>
							</Form.Group>
						</Col>
						<Col>
							{idx !== 0 ? (
								<Button
									variant="danger"
									onClick={() => {
										if (application.participants) {
											delete application.participants[
												idx
											];
											forceUpdate();
										}
									}}
								>
									Remove
								</Button>
							) : null}
						</Col>
					</Row>
				);
			},
		);

		return (
			<>
				<strong>Participants</strong>
				<Row className="mb-3 mt-3">
					<Col sm={4}>
						<strong>Course *</strong>
					</Col>
					<Col sm={4}>
						<strong># of Participants</strong>
					</Col>
					<Col sm={4}>
						<strong> Start Date * </strong>
					</Col>
				</Row>
				{participantFields}
				<Button
					variant="primary"
					className="mb-3"
					onClick={() => {
						if (application.participants) {
							application.participants.push({
								course: "",
								numParticipants: "",
								startDate: new Date(),
							});
							forceUpdate();
						}
					}}
				>
					Add Participant
				</Button>
			</>
		);
	};

	return (
		<>
			<Row className="mb-3">
				<Col sm={12} className="mt-3">
					<Form.Label className="mb-4">
						Are you applying for an individual or group? *
					</Form.Label>
					{applyingFor.map((option, idx) => (
						<div key={`los-${idx}`} className="mb-3">
							<Form.Check
								type="radio"
								id={`appfora-${idx}`}
								name="applyingForA"
								label={option}
								value={option}
								defaultChecked={
									application.applyingForA === option
								}
								onChange={() => {
									props.application.applyingForA = option;
									forceUpdate();
								}}
							/>
						</div>
					))}
					<InputErrorMessage field="sponsorLevel" errors={errors} />
				</Col>
			</Row>

			{application.applyingForA === applyingFor[1] ? (
				<Row className="mb-3">
					<Col>
						<Form.Group controlId="groupSize">
							<Form.Label>Group Size</Form.Label>
							<Form.Control
								size="lg"
								defaultValue={application.groupSize}
								onChange={(event: any) => {
									application.groupSize = event.target.value;
									forceUpdate();
								}}
							/>
							<InputErrorMessage
								errors={errors}
								field="groupSize"
							/>
						</Form.Group>
					</Col>
				</Row>
			) : null}

			{application.applyingForA !== null ? (
				<Row className="mb-3">
					<Col>
						<Form.Group controlId="course">
							<Form.Label>Course</Form.Label>
							<Form.Control
								size="lg"
								as="select"
								defaultValue={application.courseName}
								onChange={(event: any) => {
									application.courseName = event.target.value;
									forceUpdate();
								}}
							>
								<option>-Select-</option>
								{courses.map(course => (
									<option value={course}>{course}</option>
								))}
							</Form.Control>
							<InputErrorMessage errors={errors} field="course" />
						</Form.Group>
					</Col>
				</Row>
			) : null}

			{application.applyingForA === applyingFor[1] ? (
				participantList()
			) : (
				<strong>Here</strong>
			)}
			<Row className="mb-3">
				<Col sm={12} className="mt-3">
					<Form.Label className="mb-4">
						Do you have paper-based Application Forms to upload? *
					</Form.Label>
					{["Yes", "No"].map((option, idx) => (
						<div key={`pppa-${idx}`} className="mb-3">
							<Form.Check
								type="radio"
								id={`pppa-${idx}`}
								name="hasPaperBasedApplications"
								label={option}
								value={option}
								defaultChecked={
									application.hasPaperBasedApplications ===
									option
								}
								onChange={() => {
									props.application.hasPaperBasedApplications = option;
									forceUpdate();
								}}
							/>
						</div>
					))}
					<InputErrorMessage
						field="hasPaperBasedApplications"
						errors={errors}
					/>
				</Col>
			</Row>
			{props.application.hasPaperBasedApplications === "Yes" ? (
				<Row className="mb-4">
					<Col sm={12} className="mt-3">
						<Form.Label className="mb-4">
							Upload Application Forms *
						</Form.Label>
						<ApplicationDropzone
							application={application}
							fileIdentifier="paperbased-app"
							onUploadComplete={() => {
								setErrors(null);
								forceUpdate();
							}}
						/>
						<InputErrorMessage
							errors={errors}
							field="hasUploadedPaperbasedApplications"
						/>
					</Col>
					<Col sm={12} className="pt-4">
						{uploadedAttachements.length ? (
							<>
								<strong>Uploaded Files</strong>
								<ul>
									{uploadedAttachements.map(
										(attachment, idx) => {
											return (
												<li key={idx}>
													{attachment.filename}
												</li>
											);
										},
									)}
								</ul>
							</>
						) : null}
					</Col>
				</Row>
			) : null}
			{application.participant &&
			application.applyingForA === applyingFor[0] ? (
				<>
					<Row className="mb-3">
						<Col>
							<Form.Group controlId="firstName">
								<Form.Label>
									Participant First Name *
								</Form.Label>
								<Form.Control
									size="lg"
									defaultValue={
										application.participant.firstName
									}
									onChange={(event: any) => {
										if (application.participant) {
											application.participant.firstName =
												event.target.value;
											forceUpdate();
										}
									}}
								/>
								<InputErrorMessage
									errors={errors}
									field="firstName"
								/>
							</Form.Group>
						</Col>
						<Col>
							<Form.Group controlId="lastName">
								<Form.Label>Participant Last Name *</Form.Label>
								<Form.Control
									size="lg"
									defaultValue={
										application.participant.lastName
									}
									onChange={(event: any) => {
										if (application.participant) {
											application.participant.lastName =
												event.target.value;
											forceUpdate();
										}
									}}
								/>
								<InputErrorMessage
									errors={errors}
									field="lastName"
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col sm={8} className="mb-3">
							<Form.Group controlId="country">
								<Form.Label>Country</Form.Label>
								<CountryDropdown
									classes="form-control form-control-lg"
									value={
										application.participant
											.country as string
									}
									priorityOptions={["JM"]}
									onChange={val => {
										if (application.participant) {
											application.participant.country = val;
											forceUpdate();
										}
									}}
								/>
								<InputErrorMessage
									field="country"
									errors={errors}
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col sm={8} className="mb-3">
							<Form.Group controlId="email">
								<Form.Label>Email</Form.Label>
								<Form.Control
									size="lg"
									defaultValue={application.participant.email}
									onChange={(event: any) => {
										if (application.participant) {
											application.participant.email =
												event.target.value;
											forceUpdate();
										}
									}}
								/>
								<InputErrorMessage
									errors={errors}
									field="email"
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col sm={8} className="mb-3">
							<Form.Group controlId="phone">
								<Form.Label>Mobile Number</Form.Label>
								<Form.Control
									size="lg"
									defaultValue={application.participant.phone}
									onChange={(event: any) => {
										if (application.participant) {
											application.participant.phone =
												event.target.value;
											forceUpdate();
										}
									}}
								/>
								<InputErrorMessage
									errors={errors}
									field="phone"
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col sm={8} className="mb-3">
							<Form.Group controlId="birthday">
								<Form.Label> Date of Birth </Form.Label>
								<DatePicker
									showYearDropdown
									className="form-control form-control-lg"
									selected={application.participant.birthday}
									onChange={(d: Date) => {
										if (application.participant) {
											application.participant.birthday = d;
											forceUpdate();
										}
									}}
								/>
								<InputErrorMessage
									errors={errors}
									field="birthday"
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col sm={8} className="mb-3">
							<Form.Group controlId="gender">
								<Form.Label>Gender</Form.Label>
								<Form.Control
									as="select"
									size="lg"
									defaultValue={
										application.participant.gender
									}
									onChange={(event: any) => {
										if (application.participant) {
											application.participant.gender =
												event.target.value;
											forceUpdate();
										}
									}}
								>
									<option>-Select-</option>
									{genders.map(gender => (
										<option value={gender}>{gender}</option>
									))}
								</Form.Control>
								<InputErrorMessage
									errors={errors}
									field="gender"
								/>
							</Form.Group>
						</Col>
					</Row>{" "}
				</>
			) : null}

			<Row>
				<Col>
					<Button
						variant="primary"
						size="lg"
						className="pull-left btn-next"
						onClick={() => props.jumpToStep(props.nextStep - 2)}
					>
						Previous
					</Button>
					<Button
						variant="primary"
						size="lg"
						className="float-right btn-next"
						onClick={validateStep}
					>
						Next
					</Button>
				</Col>
			</Row>
		</>
	);
};
